import React from 'react';
import { FadeIn, CTAButton } from './ui';
import { ShieldCheck } from 'lucide-react';
export function OfferSection() {
  return <section className="bg-navy py-20 px-6 md:py-28 text-white relative overflow-hidden" data-id="element-125">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10" data-id="element-126">
        <div className="absolute -top-40 -left-40 w-96 h-96 bg-sage rounded-full blur-3xl" data-id="element-127"></div>
        <div className="absolute -bottom-40 -right-40 w-96 h-96 bg-coral rounded-full blur-3xl" data-id="element-128"></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-129">
        <div className="text-center mb-12" data-id="element-130">
          <FadeIn data-id="element-131">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-cream mb-6" data-id="element-132">
              Recupera tu vitalidad y desinflama tu cuerpo hoy mismo.
            </h2>
          </FadeIn>
          <FadeIn delay={0.1} data-id="element-133">
            <p className="text-xl md:text-2xl text-sage font-medium" data-id="element-134">
              Accede al sistema completo "Metabolismo 40+ Reset" por un pago
              único de inversión mínima.
            </p>
          </FadeIn>
        </div>

        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-10" data-id="element-135">
          <FadeIn delay={0.2} className="w-full md:w-1/2" data-id="element-136">
            <img src="https://cdn.magicpatterns.com/uploads/x2gZGykB1rAvhJ9C1J7YqW/metabolismo_2B_40.png" alt="Metabolismo 40+ Reset Bundle" className="w-full h-auto rounded-xl shadow-md" data-id="element-137" />
          </FadeIn>

          <FadeIn delay={0.3} className="w-full md:w-1/2 text-center md:text-left" data-id="element-138">
            <div id="offer" className="mb-2 text-gray-500 font-bold uppercase tracking-wider text-sm scroll-mt-24" data-id="element-139">
              Precio Especial de Lanzamiento
            </div>
            <div className="text-5xl md:text-6xl font-bold text-navy mb-8 font-serif" data-id="element-140">
              $6.40
            </div>

            <CTAButton className="w-full mb-6 text-xl py-5" href="https://vitalyreset.com/cart/50443897700598:1" data-id="element-141" />

            <div className="flex items-center justify-center md:justify-start gap-2 text-gray-600 font-medium" data-id="element-142">
              <ShieldCheck className="w-5 h-5 text-green-600" data-id="element-143" />
              <span data-id="element-144">Pago seguro y descarga instantánea</span>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}